import { Box, Center, Text } from '@chakra-ui/react';

export const WebcamOverlay = (): JSX.Element => (
  <>
    <Box
      position="absolute"
      top="0"
      left="0"
      right="0"
      bottom="0"
      bg="rgba(0, 0, 0, 1)"
      sx={{
        WebkitMask:
          'radial-gradient(ellipse 35% 40% at center, transparent 98%, black 99%)',
        mask: 'radial-gradient(ellipse 35% 40% at center, transparent 98%, black 99%)',
      }}
    />

    <Center position="absolute" top="4" left="0" right="0" pointerEvents="none">
      <Text color="white" fontSize="md" fontWeight="medium">
        Centralize seu rosto na área oval
      </Text>
    </Center>
  </>
);
